
import './pl_landlord.css';
import StaffMockHost from './staff-mock-host.vue';

var COL_DEFS = [
  { lines: ['日数'], field: 'nights', width: 80 },
  { lines: ['人数'], field: 'guest_count', width: 80 },
  { lines: ['A総売上'], field: 'A', width: 80 },
  { lines: ['Bサイト手数料', '（A〇％）'], field: 'B', width: 96 },
  { lines: ['C弊社報酬', '（A〇％）'], field: 'C', width: 80 }
];

export default {
  name: 'pl-landlord-stay-tax',
  components: {
    StaffMockHost: StaffMockHost
  },
  data: function () {
    var now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      keyword: '',
      columns: COL_DEFS,
      rooms: [],
      totals: {}
    };
  },
  computed: {
    visibleRooms: function () {
      var kw = (this.keyword || '').trim();
      if (!kw) return this.rooms;
      return (this.rooms || []).filter(function (room) {
        return String(room.room_name || '').indexOf(kw) !== -1;
      });
    },
    panes: function () {
      var rooms = this.visibleRooms || [];
      var mid = Math.ceil(rooms.length / 2);
      return [
        { key: 'left', showTotal: true, rooms: rooms.slice(0, mid) },
        { key: 'right', showTotal: false, rooms: rooms.slice(mid) }
      ];
    }
  },
  watch: {
    year: function () {
      this.loadOverview();
    },
    month: function () {
      this.loadOverview();
    }
  },
  created: function () {
    this.loadOverview();
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else this.toast('取得に失敗しました');
    },
    shiftYear: function (delta) {
      var next = Number(this.year) + delta;
      if (next < 2000 || next > 2100) return;
      this.year = next;
    },
    shiftMonth: function (delta) {
      var m = Number(this.month) + delta;
      var y = Number(this.year);
      if (m < 1) {
        m = 12;
        y -= 1;
      } else if (m > 12) {
        m = 1;
        y += 1;
      }
      this.year = y;
      this.month = m;
    },
    printPdf: function () {
      window.print();
    },
    cellText: function (room, field) {
      if (!room || room[field] == null || room[field] === '') return '';
      return this.formatNum(room[field]);
    },
    totalCell: function (field) {
      var totals = this.totals || {};
      if (totals[field] == null || totals[field] === '') return '';
      return this.formatNum(totals[field]);
    },
    formatNum: function (n) {
      if (n == null || n === '') return '';
      var num = Number(n);
      if (!isFinite(num)) return n;
      return String(Math.round(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    applyOverview: function (opt) {
      opt = opt || {};
      this.rooms = opt.rooms || [];
      this.totals = opt.totals || {};
    },
    loadOverview: function () {
      var t = this;
      axios.get('settlement/companyOverview', {
        params: { year: t.year, month: t.month }
      }).then(function (res) {
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          t.rooms = [];
          t.totals = {};
          return;
        }
        t.applyOverview(res.data.options || {});
      }).catch(function () {
        t.toast('通信に失敗しました');
        t.rooms = [];
        t.totals = {};
      });
    }
  }
};
